import React from 'react';
import { Modal, Container, Row, Col } from 'reactstrap';
import { Input } from 'antd';
import numeral from 'numeral';

import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';

export default withNamespaces()(ModalTranc);
function ModalTranc(props) {
  const { t } = props;
  const { onTranc, onTestFailTranc } = props;

  const context = React.useContext(ApiContext);

  const items = [
    10, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000, 10000,
  ];

  return (
    <Modal
      isOpen={context.showTranc}
      toggle={() => context.setShowTranc(false)}
      zIndex={1}
    >
      <Container style={{ padding: 20, background: '#1E3845' }}>
        <Row className={'justify-content-center align-items-center'}>
          <div style={{ color: 'whitesmoke' }}>
            {t('ModalTranc.PleaseSelectDepositAmount')}
          </div>
        </Row>

        <Row className={'justify-content-center align-items-center my-4'}>
          <div style={{ width: 150 }}>
            <Input
              prefix={'$'}
              suffix={context.symbol}
              value={context.coinValue}
              onChange={(e) => context.setCoinValue(e.target.value)}
            />
          </div>

          <button
            className={'btn btn-success ml-4'}
            onClick={() => onTranc(context.coinValue)}
          >
            {t('ModalTranc.Deposit')}
          </button>

          <button
            className={'btn btn-danger ml-4'}
            onClick={() => onTestFailTranc(context.coinValue)}
          >
            充值失敗測試
          </button>
        </Row>

        <Row>
          {items.map((element, index) => {
            return (
              <Col key={index} xs={4}>
                <button
                  className={'btn btn-outline-success my-2'}
                  onClick={() => onTranc(element)}
                >
                  {`${numeral(element).format('0,0')} ${context.symbol}`}
                </button>
              </Col>
            );
          })}
        </Row>
      </Container>
    </Modal>
  );
}
